"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const TimesSolid_1 = __importDefault(require("../../../../IconsNavigation/TimesSolid"));
const Modal_1 = __importDefault(require("../../../../Modal/Modal"));
const QRCode_1 = __importDefault(require("../../../../QRCode/QRCode"));
const StoreToggle_1 = __importDefault(require("../StoreToggle"));
const verse_app_screenshot_png_1 = __importDefault(require("../../../../../static/downloads/verse-app-screenshot.png"));
const loading_spinner_png_1 = __importDefault(require("../../../../../static/downloads/loading-spinner.png"));
const qr_png_1 = __importDefault(require("../../../../../static/downloads/qr.png"));
const styled_1 = require("./styled");
const QrCodeModal = () => {
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const modalRef = (0, react_1.useRef)(null);
    const [selectedStore, setSelectedStore] = (0, react_1.useState)("GOOGLE_PLAY");
    const qrValue = selectedStore === "GOOGLE_PLAY"
        ? formatMessage({ id: "buy.nowallets-google-link" })
        : formatMessage({ id: "buy.nowallets-app-store-link" });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styled_1.ModalCTA, { className: "ga-wallet-cta get-app-cta-button", onClick: () => modalRef.current && modalRef.current.open() },
            react_1.default.createElement(styled_1.QrImg, { src: qr_png_1.default, alt: "qr" }),
            react_1.default.createElement(styled_1.QrText, null, formatMessage({ id: "buy.qrcodeModal-button" }))),
        react_1.default.createElement(styled_1.ModalWrapper, null,
            react_1.default.createElement(Modal_1.default, { ref: modalRef, closeButton: {
                    top: 28,
                    right: 33.5,
                    icon: react_1.default.createElement(TimesSolid_1.default, { height: 13.5 }),
                } },
                react_1.default.createElement(styled_1.ColumnContainer, null,
                    react_1.default.createElement(styled_1.ImageWrapper, null,
                        react_1.default.createElement("img", { src: verse_app_screenshot_png_1.default, alt: "app-screenshot" })),
                    react_1.default.createElement(styled_1.ContentWrapper, null,
                        react_1.default.createElement(styled_1.StyledTitle, null, formatMessage({ id: "buy.qrcodeModal-title" })),
                        react_1.default.createElement(StoreToggle_1.default, { selectedStore: selectedStore, setSelectedStore: setSelectedStore }),
                        react_1.default.createElement(styled_1.QrCodeWrapper, null,
                            react_1.default.createElement(QRCode_1.default, { value: qrValue, imageSettings: { src: loading_spinner_png_1.default } }))))))));
};
exports.default = QrCodeModal;
//# sourceMappingURL=QrCodeModal.js.map